import { AssignInvoiceCriteriaEntity } from "domain/entity/AssignInvoiceCriteria/AssignInvoiceCriteriaEntity";
import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { axiosPostData } from "../axios/AxiosBasicImpl";
import recalAxiosInstance from "../axios/recalAxiosInstance";
import { AssignInvoiceCriteriaRepository } from "./AssignInvoiceCriteriaRepo";

export const AssignInvoiceCriteriaRepoImpl = (): AssignInvoiceCriteriaRepository => {

    const onSubmit = async (criteria: AssignInvoiceCriteriaEntity): Promise<ResponseEntity> => {
        const newUrl = "/v1/assignInvoiceCriteria/submit";
        return axiosPostData(recalAxiosInstance, `${newUrl}`, criteria);
    }

    return {
        onSubmit: onSubmit
    }
}